import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { ASSIGNMENTS_QUERIES } from "~/shared/api/assignments/assignments.queries";
import { notFound } from "~/shared/util/notFound";

export function assignmentSubmissionViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { submissionId } = params;

  if (!submissionId) {
    return notFound();
  }

  queryClient.prefetchQuery(ASSIGNMENTS_QUERIES.user.detail(submissionId));

  return null;
}
